import { XIcon } from "@heroicons/react/solid";
import { forwardRef } from "react";
import { createStore } from "react-hooks-global-state";
import { useSpring, animated } from "react-spring";
import useMeasure from "react-use-measure";

const PopWindowReducer = (state, action) => {
    switch (action.type) {
        case "pop": {
            const { popWindows } = state;

            popWindows.forEach(p => {
                p.state = "hiding";
            })

            return {
                ...state,
                popWindows: [...popWindows, action.value]
            };
        }
        case "update": {
            const { popWindows } = state;
            const popWindow = action.value;
            for (let i = 0; i < popWindows.length; i++) {
                if (popWindows[i].id == popWindow.id) {
                    popWindows[i] = popWindow;
                    break;
                }
            }

            if (popWindows.length > 1 && popWindows[popWindows.length - 1].state == "closing") {
                popWindows[popWindows.length - 2].state = "popping";
            }

            return {
                ...state,
                popWindows: [...popWindows]
            };
        }
        case "remove": {
            const { popWindows } = state;
            const popWindow = action.value;
            for (let i = 0; i < popWindows.length; i++) {
                if (popWindows[i].id == popWindow.id) {
                    popWindows.splice(i, 1);
                }
            }

            return {
                ...state,
                popWindows: [...popWindows]
            };
        }
    }
}


const { dispatch, useGlobalState } = createStore(PopWindowReducer, { popWindows: [] })

const ViewWrapper = ({ view }) => {
    const [ref, measure] = useMeasure();
    const styles = useSpring({
        to: { top: view.state == "popping" ? -measure.height : 0 },
        onRest: {
            top: () => {
                if (view.state == "closing") {
                    //关闭动画播完了
                    dispatch({ type: "remove", value: view })
                }
            }
        }
    })

    const onViewAction = (act) => {
        let action = act;
        if (typeof action == "string") {
            action = { name: action };
        }

        if (action.name == "close") {
            view.state = "closing";
            dispatch({ type: "update", value: view })
        }
        if (view.onViewAction != null) {
            view.onViewAction(action);
        }
    }

    const V = view.view;
    return <div className="relative w-full top-full popWindow">
        <animated.div ref={ref} className=" absolute w-full"
            style={styles}>
            <div className="flex flex-col w-full bg-white p-4 pb-8  rounded-t-md">
                <div className="flex w-fullitems-center pb-4">
                    <div className="w-6"></div>
                    <div className="flex w-full text-sm items-center justify-center font-semibold">{view.title}</div>
                    <div className="w-6 h-6 text-gray-500"><XIcon className="w-6 h-6"
                        onClick={e => {
                            onViewAction("close");
                        }} /></div>
                </div>
                <V onViewAction={onViewAction} id={view.id} {...view.args} />
            </div>

        </animated.div>
    </div>
}

export const usePopWindow = () => {
    const [popWindows] = useGlobalState('popWindows')

    const findWndById = (id) => {
        for (const idx in popWindows) {
            if (popWindows[idx].id == id) {
                return popWindows[idx];
            }
        }
        return null;
    }

    /**
     * 
     * @param {String} id pop id
     * @param {Hook Func} view 弹出窗口
     * @param {String} title 窗口标题
     * @param {Function(action:{name:String, ...})} onViewAction anction回调
     * @param {{}} args 传入参数 
     * @returns 
     */
    const pop = (id, view, title, onViewAction, args) => {
        if (findWndById(id) != null) {
            return false;
        }
        dispatch({ type: "pop", value: { id: id, view: view, title: title, onViewAction: onViewAction, args: args, state: "popping" } })
        return true;
    }

    return [pop]
}

export const BottomPopWindow = () => {
    const [popWindows] = useGlobalState('popWindows')

    const bgStyle = useSpring({
        //from: { backgroundColor: popWindows.length == 0 ? '#00000080' : '#00000000' },
        to: {
            //popWindows中没有窗口，或者只有1个正在关闭的窗口时，淡出背景
            backgroundColor: popWindows.length == 0 ||
                (popWindows.length == 1 && popWindows[0].state == "closing") ? '#00000000' : '#00000080'
        },
    });

    const cn = popWindows.length == 0 ? "fixed inset-0 z-15 bg-black pointer-events-none" :
        "fixed inset-0 z-15 bg-black ";

    // const view = popWindows.length == null ? null : popWindows[popWindows.length - 1];

    // const wnd = view == null ? null : <ViewWrapper view={view} />

    //const V = view == null ? null : view.view;
    //const wnd = view == null ? null : <V onViewAction={view.onViewAction} id={view.id} />


    const wnds = [];
    popWindows.forEach(pw => {
        wnds.push(<ViewWrapper view={pw} key={pw.id} />);
    })

    return <animated.div className={cn} style={bgStyle} id="popwindow_bg" onClick={e => {
        if (e.target.id == "popwindow_bg") {
            if (popWindows.length > 0) {
                const w = popWindows.slice(-1)[0];
                w.state = "closing";
                dispatch({ type: "update", value: w })
            }
        }
    }}>
        {wnds}
    </animated.div>
}